export enum ClientType {
    WEBGL = 'webgl'
}
